import styled from "styled-components";

import { PrimaryButton } from "../../../styledComponents/buttons";

export const IntegrationNameContainer = styled.div``;

export const WorkflowsContainer = styled.div`
  margin-top: 15px;
`;

export const WorkflowCard = styled.div`
  padding: 20px;

  width: 70%;
  max-width: 700px;

  background-color: ${({ theme }) => theme.colors.main.white};
  border: 1px solid
    ${({ theme, enabled }) =>
      enabled
        ? theme.colors.border.primary
        : theme.colors.border.secondaryLight};
  border-radius: ${({ theme }) => theme.borderRadii.card};

  &:not(:first-child) {
    margin-top: 12px;
  }
`;

export const ReinviteButton = styled(PrimaryButton)`
  background-color: #E9F0FE;
  color: ${({ theme }) => theme.button.primary.bgColor};

  &:hover {
    background-color: ${({ theme }) => theme.colors.hover.primary};
    color: ${({ theme }) => theme.button.primary.textColor};
  }

`;
